import { useEffect } from "react";
import { useSelector } from "react-redux";
import { manageAuthorizationSelector } from "../../../Selectors/AuthorizationSelector";
import {
  BASE_ROUTE,
  CONFIRM_SITE_ACCESS_ROUTES,
  EMPTY,
  NOT_SIGNED_IN,
  PAGE_VIEW,
  SIGNED_IN,
  SIGNED_IN_ROUTES,
  STATIC_DATA,
} from "../../../Constants/CommonConstants";
import { useLocation } from "react-router-dom";

const GTMWrapper = () => {
  const locations = useLocation();
  const { hapId, scopes } = useSelector((state) =>
    manageAuthorizationSelector(state)
  );
  const currentPageName = location.pathname?.split(BASE_ROUTE).slice(-1)[0];
  const pageNameArray = location.pathname?.split(STATIC_DATA)[1];
  const pageURLSubString = pageNameArray?.split(BASE_ROUTE)[0];
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    if (!CONFIRM_SITE_ACCESS_ROUTES?.includes(locations.pathname)) {
      window.dataLayer.push({
        event: PAGE_VIEW,
        hapId: hapId || EMPTY,
        pageName: currentPageName,
        userSignIn: SIGNED_IN_ROUTES.includes(locations.pathname)
          ? SIGNED_IN
          : NOT_SIGNED_IN,
        destinationPageUrl: window.location.href,
        pageCategory: pageURLSubString,
        userType: scopes || EMPTY,
      });
    }
  }, [locations]);

  return <></>;
};
export default GTMWrapper;
